import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { QuoteForm } from "@/components/landing/QuoteForm";
import { WhyUs } from "@/components/landing/WhyUs";
import { Faq } from "@/components/landing/Faq";
import { Footer } from "@/components/landing/Footer";
import { WhatsAppFloat } from "@/components/WhatsApp";
import { ChatBot } from "@/components/ChatBot";

export default function Landing() {
  return (
    <main className="bg-industrial-950 text-slate-100 overflow-x-clip">
      <Navbar />
      <Hero />
      <Marquee />
      <HowItWorks />
      <QuoteForm />
      <WhyUs />
      <Faq />
      <Footer />
      <WhatsAppFloat />
      <ChatBot />
    </main>
  );
}
